import { render, staticRenderFns } from "./admin-content.vue?vue&type=template&id=125638a0&"
import script from "./admin-content.vue?vue&type=script&lang=ts&"
export * from "./admin-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports